import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as KYCDone } from "../../../assets/illustrations/kyc-done-240x240.svg";
import { Button, Icon } from "../../../components/common";
import ServicesLayout from "../../../layouts/Services.layout";
import { ROUTES } from "../../../routes";

export const OnmetaKYCSuccess: FC = () => {
  const navigate = useNavigate();

  return (
    <ServicesLayout image={<KYCDone />} title="Your profile has been verified">
      <div className="flex flex-col items-stretch gap-12">
        <div className="flex flex-col items-center gap-4">
          <Icon
            icon="check_circle_outline"
            size={64}
            className="text-green-500"
          />

          <div className="font-poppins font-bold text-xl">
            You're all set to do business
          </div>
        </div>

        <div className="flex justify-center mt-4">
          <Button
            variant={Button.variant.PRIMARY}
            onClick={() => navigate(ROUTES.HOME)}
          >
            Get transfers now
          </Button>
        </div>
      </div>
    </ServicesLayout>
  );
};
